import type { ReactNode } from 'react';

interface EmptyStateProps {
  /** Optionales Icon (z.B. ein lucide-Icon), dezent eingefärbt zentriert oben. */
  icon?: ReactNode;
  title: string;
  description?: string;
  /** Optionale Aktion (z.B. ein Button), unter der Beschreibung. */
  action?: ReactNode;
}

/**
 * Gebrandeter Leerzustand: zentriert, muted, großzügiges Padding. Für „keine
 * Daten"-Situationen (leere Listen, leere Galerie). Icon sitzt in einem dezent
 * akzent-getönten Kreis, Titel in Ink, Beschreibung muted.
 */
export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex animate-fade-in flex-col items-center justify-center gap-3 px-6 py-12 text-center">
      {icon && (
        <div className="flex h-14 w-14 items-center justify-center rounded-pill bg-kalkuel-accent-soft text-kalkuel-accent-strong ring-4 ring-kalkuel-accent-soft/40">
          {icon}
        </div>
      )}
      <div className="space-y-1">
        <p className="text-sm font-semibold text-kalkuel-ink">{title}</p>
        {description && <p className="text-xs text-kalkuel-muted">{description}</p>}
      </div>
      {action && <div className="mt-1">{action}</div>}
    </div>
  );
}
